import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    setBusy(true);
    try {
      await signup(email, password, name);
      toast.success("Welcome to the adventure ✨");
      nav("/studio");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not sign up");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container-narrow py-20 grid lg:grid-cols-2 gap-12 items-center" data-testid="signup-page">
      <div className="hidden lg:block">
        <div className="label-eyebrow mb-3">Begin</div>
        <h1 className="font-heading text-5xl font-semibold leading-tight mb-4">
          Build Apple apps <span className="italic text-marigold">with words</span>.
        </h1>
        <p className="text-ink2 max-w-md">
          Free forever to start. 5 app prompts a month, the beginner path, and previews of every pop-up book.
        </p>
      </div>
      <form onSubmit={submit} className="card-soft p-8 max-w-md w-full mx-auto" data-testid="signup-form">
        <h2 className="font-heading text-2xl font-semibold mb-6">Create your account</h2>
        <label className="text-sm font-medium block mb-1">Name</label>
        <input required value={name} onChange={e => setName(e.target.value)} className="input-soft mb-4" data-testid="signup-name" />
        <label className="text-sm font-medium block mb-1">Email</label>
        <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="input-soft mb-4" data-testid="signup-email" />
        <label className="text-sm font-medium block mb-1">Password</label>
        <input type="password" required minLength={6} value={password} onChange={e => setPassword(e.target.value)} className="input-soft mb-6" data-testid="signup-password" />
        <button className="btn-primary w-full justify-center" disabled={busy} data-testid="signup-submit">
          {busy ? "Creating…" : "Start free"}
        </button>
        <p className="text-sm text-ink2 mt-5 text-center">
          Already have an account? <Link to="/login" className="text-marigold font-medium" data-testid="signup-to-login">Log in</Link>
        </p>
      </form>
    </div>
  );
}
